import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import PublicHeader from './header'
import { StyleOutletWrapper } from './style'
import { Helper } from '@utils'
import { Navigate } from 'react-router-dom'
const PublicLayout = () => {
  const { pathname } = useLocation()
  const user = Helper.getUser()
  const isWhite = [
    '/',
    '/about-us',
    '/service',
    '/blogs',
    '/contact-us',
  ].includes(pathname)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  if (!!['/login', '/register-as-provider'].includes(pathname) && !!user?.id) {
    return <Navigate to={`/${user?.role}`} />
  }

  return (
    <>
      <PublicHeader />
      <main>
        <StyleOutletWrapper isWhite={isWhite}>
          <Outlet />
        </StyleOutletWrapper>
      </main>
    </>
  )
}

export default PublicLayout
